// Utils
import cn from '../../../../utils/cn';
import { formatTime } from '../../../../utils/formatDate';
// Styles
import styles from './SimpleTimeCell.module.css';

/**
 * Simple time cell component for SimpleTable
 * @param {object} props
 * @param {string} [props.value] - Time value in HH:mm format
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.placeholder='--:--'] - Placeholder for empty values
 * @param {'left' | 'center' | 'right'} [props.align='center'] - Text alignment
 * @param {boolean} [props.bold=false] - Text in bold
 * @param {boolean} [props.italic=false] - Text in italic
 * @returns {JSX.Element}
 */
function SimpleTimeCell({
  value,
  className = '',
  placeholder = '--:--',
  align = 'center',
  bold = false,
  italic = false,
}) {
  const isEmpty = !value || value === '';
  const formattedValue = isEmpty ? placeholder : formatTime(value);

  return (
    <div className={cn([
      styles['simple-time-cell'],
      className,
      bold && styles['simple-time-cell-bold'],
      italic && styles['simple-time-cell-italic'],
      align && styles[`simple-time-cell-align-${align}`],
    ])}
    >
      <div
        className={styles['simple-time-cell-value']}
        title={formattedValue}
      >
        {formattedValue}
      </div>
    </div>
  );
}

export default SimpleTimeCell;
